import React from 'react';
import { Box, Typography } from '@mui/material';
import { secondaryColors } from '../../theme/themeConfig';

interface SettingsCardProps {
  children: React.ReactNode;
  description?: string;
  rightAction?: React.ReactNode;
  title?: string;
}

function SettingsCard({
  children,
  description,
  rightAction,
  title
}: SettingsCardProps) {
  return (
    <Box
      sx={{
        background: '#fff',
        border: `1px solid ${secondaryColors.SECONDARY_6}`,
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(15,28,46,.06)',
        mb: 2,
        overflow: 'hidden'
      }}
    >
      {title && (
        <Box
          sx={{
            alignItems: 'center',
            background: '#F4F7FB',
            borderBottom: `1px solid ${secondaryColors.SECONDARY_6}`,
            display: 'flex',
            justifyContent: 'space-between',
            p: '14px 24px'
          }}
        >
          <Box>
            <Typography
              sx={{
                color: '#0f1c2e',
                fontSize: '14px',
                fontWeight: 600
              }}
            >
              {title}
            </Typography>
            {description && (
              <Typography
                sx={{
                  color: secondaryColors.SECONDARY,
                  fontSize: '12px',
                  mt: 0.25
                }}
              >
                {description}
              </Typography>
            )}
          </Box>
          {rightAction && <Box>{rightAction}</Box>}
        </Box>
      )}
      <Box sx={{ p: '20px 24px' }}>{children}</Box>
    </Box>
  );
}

SettingsCard.defaultProps = {
  description: undefined,
  rightAction: undefined,
  title: undefined
};

export default SettingsCard;
